export default __webpack_public_path__ + "static/media/1.64896f7d.png";